export default __webpack_public_path__ + "static/B0121-83c95101908971c418b0e1176ef56efb.png";